// extracted by mini-css-extract-plugin
export default {"requiredIndicator":"styles-module__requiredIndicator__b8d6cbd1fffd3fe8bcb7"};